import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=7512cc08&"
import script from "./ItemDetail.vue?vue&type=script&lang=js&"
export * from "./ItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7512cc08', component.options)
    } else {
      api.reload('7512cc08', component.options)
    }
    module.hot.accept("./ItemDetail.vue?vue&type=template&id=7512cc08&", function () {
      api.rerender('7512cc08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Index/ItemDetail.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Index/ItemDetail.vue
// module id = jl5G
// module chunks = 0